/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AutomaticEmailStepOverride } from './automaticEmailStepOverride';
import type { CustomTaskStepOverride } from './customTaskStepOverride';
import type { LinkedInConnectionRequestStepOverride } from './linkedInConnectionRequestStepOverride';
import type { LinkedInMessageStepOverride } from './linkedInMessageStepOverride';
import type { LinkedInProfileViewStepOverride } from './linkedInProfileViewStepOverride';
import type { ManualEmailStepOverride } from './manualEmailStepOverride';
import type { PhoneCallStepOverride } from './phoneCallStepOverride';
import type { TextMessageStepOverride } from './textMessageStepOverride';

export type EnrollmentPreviewPatchRequestSetOverrides = {[key: string]: {[key: string]: AutomaticEmailStepOverride | ManualEmailStepOverride | PhoneCallStepOverride | TextMessageStepOverride | CustomTaskStepOverride | LinkedInProfileViewStepOverride | LinkedInConnectionRequestStepOverride | LinkedInMessageStepOverride}} | null;
